import { ChainId } from '../../sdk/chainId'
import type { ChainDefinition } from '../types'

import { buildAllChains } from './buildFromProductConfig'

const chains = buildAllChains()

export const infiniteMainnetChain: ChainDefinition = chains[ChainId.INFINITE_MAINNET]
export const infiniteTestnetChain: ChainDefinition = chains[ChainId.INFINITE_TESTNET]
export const infiniteCreativeChain: ChainDefinition = chains[ChainId.INFINITE_CREATIVE]

/** Catálogo canónico por `chainId`. */
export const CHAINS: Record<ChainId, ChainDefinition> = chains

export const ALL_CHAIN_IDS: ChainId[] = [
  ChainId.INFINITE_MAINNET,
  ChainId.INFINITE_TESTNET,
  ChainId.INFINITE_CREATIVE,
]
